export default __webpack_public_path__ + "static/media/clearp01.6b0f40da.png";